import { ArrowDownIcon, ArrowUpIcon } from '@/components/icons'
import {
  Collapse,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from '@mui/material'
import { Stack } from '@mui/system'
import { FC, useState } from 'react'

interface PipesTableProps {
  rows: {
    id: string
    subpipe: string
    pipe: string
    pipeCapacity: string
  }[]
}

const PipesTable: FC<PipesTableProps> = ({ rows }) => {
  const [open, setOpen] = useState<{ [key: string]: boolean }>({})

  return (
    <Stack flexGrow="1">
      <TableContainer
        component={Paper}
        elevation={0}
        sx={{
          backgroundColor: 'common.white',
          border: '1px solid #EFEFEF',
          borderRadius: '3px',
          '&::-webkit-scrollbar': {
            width: '8px',
            height: '8px',
          },

          '&::-webkit-scrollbar-thumb': {
            backgroundColor: '#C1C1C1',
            borderRadius: '5px',
          },
        }}
      >
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead sx={{ backgroundColor: '#EFEFEF' }}>
            <TableRow>
              <TableCell
                sx={{
                  minWidth: '45px',
                  backgroundColor: '#EFEFEF',
                  position: 'sticky',
                  left: 0,
                }}
              >
              </TableCell>
              <TableCell
                sx={{
                  minWidth: '117px',
                  borderRight: '1px solid #D7D7D7',
                  backgroundColor: '#EFEFEF',
                  position: 'sticky',
                  left: 0,
                }}
              >
                Type
              </TableCell>
              <TableCell
                sx={{
                  minWidth: '531.5px',
                }}
              >
                Pipe
              </TableCell>
              <TableCell
                sx={{
                  minWidth: '531.5px',
                }}
              >
                Pipe Capacity (l/m)
              </TableCell>
              <TableCell
                sx={{
                  minWidth: '107px',
                }}
              >
                Action
              </TableCell>

            </TableRow>
          </TableHead>
          <TableBody sx={{ backgroundColor: 'common.white' }}>
            {rows.map((row, index) => (
              <>
                <TableRow key={row.id}>
                  <TableCell
                    component="th"
                    scope="row"
                    sx={{
                      position: 'sticky',
                      left: 0,
                      backgroundColor: '#FFFFFF',
                    }}
                  ><IconButton
                    aria-label="expand row"
                    size="small"
                    onClick={() => setOpen({ ...open, [`${index}`]: !open[index] })}
                  >
                      {open[index] ? <ArrowUpIcon /> : <ArrowDownIcon />}
                    </IconButton>
                  </TableCell>
                  <TableCell
                    sx={{
                      borderRight: '1px solid #D7D7D7',
                      position: 'sticky',
                      left: 0,
                      backgroundColor: '#FFFFFF',
                    }}
                  >
                    {row.subpipe}
                  </TableCell>
                  <TableCell>{row.pipe}</TableCell>
                  <TableCell>{row.pipeCapacity}</TableCell>
                  <TableCell>
                    <Stack direction="row" spacing="10px">
                      <Typography
                        sx={{
                          fontSize: '13px',
                          fontWeight: '500',
                          lineHeight: '100%',
                          color: 'primary.main',
                          cursor: 'pointer',
                        }}
                      >
                        EDIT
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: '13px',
                          fontWeight: '500',
                          lineHeight: '100%',
                          color: 'grey.600',
                          cursor: 'pointer',
                        }}
                      >
                        DELETE
                      </Typography>
                    </Stack>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell style={{ padding: 0, width: '100%' }} colSpan={6}>
                    <Collapse in={open[index]} timeout="auto" unmountOnExit >
                      <Table size="small" aria-label="purchases">
                        <TableBody sx={{ backgroundColor: 'rgba(4, 71, 68, 0.05)' }}>
                          <TableCell component="th"
                            scope="row"
                            sx={{
                              position: 'sticky',
                              left: 0,
                              width: '50px',
                              backgroundColor: 'rgba(235, 237, 236, 1)'
                            }} />
                          <TableCell component="th" scope="row" sx={{
                            borderRight: '1px solid #D7D7D7',
                            position: 'sticky',
                            left: 0,
                            width: '112px',
                            backgroundColor: 'rgba(235, 237, 236, 1)'
                          }}>
                            {row.subpipe}
                          </TableCell>
                          <TableCell sx={{ width: '530.5px' }}>
                            {row.pipe}
                          </TableCell>
                          <TableCell sx={{ width: '530.5px' }}>{row.pipeCapacity}</TableCell>
                          <TableCell>
                            <Stack direction="row" spacing="10px">
                              <Typography
                                sx={{
                                  fontSize: '13px',
                                  fontWeight: '500',
                                  lineHeight: '100%',
                                  color: 'primary.main',
                                  cursor: 'pointer',
                                }}
                              >
                                EDIT
                              </Typography>
                              <Typography
                                sx={{
                                  fontSize: '13px',
                                  fontWeight: '500',
                                  lineHeight: '100%',
                                  color: 'grey.600',
                                  cursor: 'pointer',
                                }}
                              >
                                DELETE
                              </Typography>
                            </Stack>
                          </TableCell>
                        </TableBody>
                      </Table>
                    </Collapse>
                  </TableCell>
                </TableRow>
              </>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

    </Stack >
  )
}

export default PipesTable
